
const routes = [
  {
    path: "/client-portal-editor",
    name: "client-portal-editor",
    component:  () => import(/* webpackChunkName: "ClientPortalEditor" */ "./views/ClientPortalEditor")
  }
];

export default routes;
